export default "__VITE_ASSET__CBbGeMlv__"